import { render, staticRenderFns } from "./RequestCustomsDispatch.vue?vue&type=template&id=02d71861&scoped=true&"
import script from "./RequestCustomsDispatch.vue?vue&type=script&lang=js&"
export * from "./RequestCustomsDispatch.vue?vue&type=script&lang=js&"
import style0 from "./RequestCustomsDispatch.vue?vue&type=style&index=0&id=02d71861&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d71861",
  null
  
)

export default component.exports